<template>
	<ul class="rating__items">
    <li class="rating__item current" v-if="currentUserRating">
			<div class="rating__num" uk-tooltip="Номер">
				{{ currentUserRating.index + 1 }}
			</div>
			<div class="rating__name">
				{{ currentUserRating.data.name }}<span v-if="currentUserRating.data.age">, {{ currentUserRating.data.age}} лет</span>
				<br>
			</div>
			<div class="rating__scores" uk-tooltip="Набрано баллов">{{ currentUserRating.data.scores }}</div>
		</li>

		<li class="rating__item" v-for="(item, key) in items" :key="item.id" :class="item.id === currentUser.id ? 'active' : ''">
			<div class="rating__num" uk-tooltip="Номер">
				{{ key + 1 }}
			</div>
			<div class="rating__name">
				{{ item.name }}<span v-if="item.age">, {{ item.age}} лет</span>
				<br>
			</div>
			<div class="rating__scores" uk-tooltip="Набрано баллов">{{ item.scores }}</div>
		</li>
	</ul>
</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    name: "rating-table",
    inject: ['http'],
    props: ['student'],
    data() {
      return {
        items: '',
        currentUserRating: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      currentUser() {
        return this.student ? this.student : this.user
      }
    },
    methods: {
      getRating(id) {
        this.http.post('onGetStudentRating', { status_id: id }).then(res => {
          this.items = res.data.filter(item => item.is_activated)

          let current = this.items.find(item => item.id === this.currentUser.id)
          console.log(current)
          this.currentUserRating = {
            index: this.items.indexOf(current),
            data: current
          }
        })        
      }
    },
	  mounted() {
      let id = this.currentUser.status.id
      this.getRating(id);
    }
  }
</script>

<style lang="scss" scoped>
.rating__item.current {
  margin-bottom: 20px;
  transform: scale(1.1);
  border: 1px solid rgba(0, 128, 218, 0.8);;
}
</style>